import React, { useState } from 'react'
import type { ChangeEvent, FormEvent } from 'react'
import emailValidator from 'email-validator'

type SignupApiResponse = {
  response: {
    success: boolean
    message?: string
  }
}

type EmailSignupFormProps = {
  action: string
  successText: string
}

const EmailSignupForm = ({ action, successText }: EmailSignupFormProps) => {
  const [email, setEmail] = useState<string>('')
  const [hasError, setHasError] = useState<boolean>(false)
  const [formErrorText, setFormErrorText] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setFormErrorText('')
    setLoading(true)

    const body = new FormData()
    body.append('email', email)

    fetch(action, {
      method: 'POST',
      body,
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data: SignupApiResponse) => {
        if (data.response.success) {
          setSuccess(true)
          return
        }

        setFormErrorText(data.response.message ?? '')
        setLoading(false)
      })
      .catch((err) => {
        console.warn(err)
        setFormErrorText(window.jsProps.strings.errorTryLater)
        setLoading(false)
      })
  }

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setEmail(value)
    setHasError(!emailValidator.validate(value))
  }

  return (
    <div className="NewsletterForm">
      {success ? (
        <p className="Text">{successText}</p>
      ) : (
        <form className="NewsletterForm__Form" onSubmit={handleSubmit}>
          <div className={'FormField ' + (hasError ? 'error' : '')}>
            <input
              className="NewsletterForm__Input FormField__Input"
              placeholder={window.jsProps.strings.mailAddress}
              onChange={handleEmailChange}
            />
            <div className="FormField__Status">
              {hasError && <span>{window.jsProps.strings.validEmail}</span>}
            </div>
          </div>

          <button
            disabled={hasError || email === '' || loading}
            type="submit"
            className={
              'Cta Cta--secondary Cta--secondary-light Cta--icon Cta--icon-arrow ' +
              (hasError || email === '' || loading ? 'disabled' : '')
            }
          >
            {loading
              ? window.jsProps.strings.pleaseWait
              : window.jsProps.strings.signup}
          </button>

          {formErrorText && (
            <div className="NewsletterForm__Error">{formErrorText}</div>
          )}
        </form>
      )}
    </div>
  )
}

export default EmailSignupForm
